import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
	NavigationState,
	NavigationActions,	
	TabType,
	ToggleTabType,
} from "./types";
import { PersistentStorageKey } from "../common/persistentStorageKey";

export const useNavigationStore = create<NavigationState & NavigationActions>()(
	persist(
		(set, _) => ({
			activeInteractionsCount: 0,
			selectedTab: TabType.Interactions,
			toggledTab: undefined,
			isMobileDetailViewMode: false,
			updateActiveInteractionsCount: (value: number) =>
				set({ activeInteractionsCount: value }),
			setSelectedTab: (tab: TabType) =>
				set((oldValue: NavigationState) =>
					oldValue.selectedTab === tab ? oldValue : { selectedTab: tab }
				),
			setToggledTab: (tab?: ToggleTabType) =>
				set((oldValue: NavigationState) =>
					oldValue.toggledTab === tab ? oldValue : { toggledTab: tab }
				),
			setIsMobileDetailViewMode: (value: boolean) =>
				set((oldValue: NavigationState) =>
					oldValue.isMobileDetailViewMode === value
						? oldValue
						: { isMobileDetailViewMode: value }
				),
		}),
		{
			name: PersistentStorageKey.Navigation,
		}
	)
);
